import { IS_MOBILE } from '@utilities/browser';

const template = ({ caption, credits, path, cssClass }) => `
<div class="photo-enlarged-wrapper">
    <div class="photo-enlarged-close js-photo-enlarged-close">
      <span class="photo-enlarged-close-icon icon-close"></span>
    </div>
    <div class="photo-enlarged">
      <figure class="${cssClass}">
        <img alt="${caption}" title="${caption}" class="pflazyload lazyfade article--img img-responsive" data-sizes="auto" srcset="${path}" />
      </figure>
      <span class="article-embedded_caption">${caption}</span>
      <span class="article-embedded_credits">${credits}</span>
    </div>
  </div>`;

export default class PhotoEnlargePlugin {
  dom: HTMLElement;

  constructor(dom: HTMLElement) {
    this.dom = dom;
  }

  init() {
    if (IS_MOBILE) return;

    const photos = this.dom.querySelectorAll<HTMLElement>('.article_picture');

    photos.forEach((photo) => {
      if (photo.classList.contains('jw-poster') || photo.classList.contains('embedded-image-free')) return;

      photo.classList.add('photo-enlargeable');
      const icon = document.createElement('pk-icon');
      icon.name = 'actions-open-in-full';
      icon.color = 'interaction-high-contrast';
      icon.classList.add('photo-enlargeable__icon');
      photo.appendChild(icon);

      photo.addEventListener('click', () => {
        const path = photo.dataset.path,
          credits = photo.dataset.credits,
          caption = photo.querySelector<HTMLImageElement>('img')?.alt;

        this.enlargePhoto(path, credits, caption, photo.querySelector('.pflazyload-wrapper')?.classList.toString());
      });

      document.addEventListener('keyup', (e) => {
        if (e.key === 'Escape' && this.target) {
          this.target.classList.remove('photo-enlarged-wrapper--visible');
        }
      });
    });
  }

  get target() {
    return document.querySelector<HTMLElement>('.photo-enlarged-wrapper');
  }

  parser = new DOMParser();
  enlargePhoto(path: string, credits: string, caption: string, cssClass: string) {
    const enlargedPhoto = this.parser.parseFromString(
      template({
        path: path,
        credits: credits,
        caption: caption,
        cssClass,
      }),
      'text/html',
    ).body;

    if (!this.target) {
      document.body.appendChild(enlargedPhoto);
    } else {
      this.target.replaceWith(enlargedPhoto);
    }

    setTimeout(() => {
      this.target.classList.add('photo-enlarged-wrapper--visible');
    }, 0);
    this.target.addEventListener('click', () => {
      this.target.classList.remove('photo-enlarged-wrapper--visible');
    });
  }
}
